<template>
  <div class="forum-description">
    <img :src="image">
    <p>{{brief}}</p>
  </div>
</template>

<script>
  export default {
    name: 'ForumDescription',
    props: ['image', 'brief']
  };
</script>

<style scoped lang="less">
  .forum-description {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    width: 60vh;
    height: 86vh;
    padding: 5vh 5vh 0;
    background-color: #f9f9f9;

    img {
      width: 100%;
    }

    p {
      margin-top: 10vh;
      line-height: 1.5;
      text-align: justify;
      font-size: 2.6vh;
      font-weight: 100;
    }
  }
</style>
